import { render, staticRenderFns } from "./FormHcactivitecreate.vue?vue&type=template&id=28842a8c&"
import script from "./FormHcactivitecreate.vue?vue&type=script&lang=js&"
export * from "./FormHcactivitecreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports